import { useEffect, useState } from "react"
import { format } from "timeago.js"
import { faClock } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import AbbrText from '../AbbrText'
import { formatDate } from '../../lib/date'

const Timeago = ({ time }) => {
    const [display, setDisplay] = useState(
        format(time)
    )
    useEffect(() => {
        const interval = setInterval(() => {
            setDisplay(
                format(time)
            )
        }, 1000)
        return () => {
            clearInterval(interval)
        }
    }, [time])
    return display
}

Timeago.Display = ({ time }) => {
    return (
        <>
            <FontAwesomeIcon icon={faClock} />
            <AbbrText title={formatDate(time)}>
                <Timeago time={time} />
            </AbbrText>
        </>
    )
}

export default Timeago